import { SplashScreen } from "@westpierstudio/luma/game";
import { OryxGame } from "@westpierstudio/core-module-oryx/game";
import { PrinceOfThievesGameController } from "game/PrinceOfThievesGameController";
import { KSGLoadingScreen } from "@westpierstudio/core-module-oryx/game/KSGLoadingScreen";
import { PrinceOfThievesGameModel } from "./PrinceOfThievesGameModel";
import { PrinceOfThievesGameView } from "./PrinceOfThievesGameView";
import { PrinceOfThievesGameClient } from "game/PrinceOfThievesGameClient";
import { GameServices } from "./GameServices";


export class PrinceOfThievesGame extends OryxGame {

    constructor(
        protected override services: GameServices,
        protected override gameModel: PrinceOfThievesGameModel,
        protected override gameView: PrinceOfThievesGameView,
        protected override gameController: PrinceOfThievesGameController,
        protected override loadingScreen: KSGLoadingScreen,
        protected override splashScreen: SplashScreen | undefined,
        protected override gameClient: PrinceOfThievesGameClient
    ) {
        super(
            services,
            gameModel,
            gameView,
            gameController,
            loadingScreen,
            splashScreen,
            gameClient
        );
    }

    protected override startApplication(): void {
        super.startApplication();
        this.services.application.renderer.backgroundColor = 0x000000;
    }

    override onSupportingResourcesLoaded() {

        const { layout, resources } = this.services;

        const padding = resources.getSetting(`bucketPadding`);

        if (padding) {

            const applyPadding = () => {
                layout.setPadding(padding[layout.orientation]);
            };

            layout.onReorient.add(() => {
                this.gameController.applyPadding();
            });
            applyPadding();
        }
    }
}